import { InfoIcon } from '@/icons';

import { DisclaimerType } from './Disclaimer.types';

export const getIcon = (type: DisclaimerType) => {
	switch (type) {
		case 'info':
		default:
			return <InfoIcon />;
	}
};
